import { ThemeProvider, CssBaseline } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { LoadingContainer } from './components/loading-container/LoadingContainer';
import { MainRouter } from './router/main';
import { theme } from "./styles";
import { AlertContainer } from '../utils/alert-container';
import '../assets/css/leaflet.css';
import { useAuthService } from '../use-cases/auth';
import { useAppSelector } from './hooks/store-hooks';

function App() {
  const { refresh } = useAuthService()
  const token = useAppSelector((state) => state.auth.token)
  const refreshRef = useRef(refresh)
  refreshRef.current = refresh

  useEffect(() => {
    if (!token || token === 'not_valid' || token === '') return

    const intervalSeconds = Number(process.env.REACT_APP_REFRESH_INTERVAL_SECONDS);

    const interval = setInterval(() => {
      refreshRef.current()
    }, intervalSeconds * 1000)

    return () => clearInterval(interval)
  }, [Boolean(token)])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LoadingContainer />
      <MainRouter />
      <AlertContainer />
    </ThemeProvider>
  );
}

export default App;